import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import template from '@cof/acq-text-ukweb/lib/plugins/transformers/template';
import merge from 'lodash.merge';
import { ThemeProvider as BaseThemeProvider } from 'styled-components';

import { useBrand } from './BrandContext';
import partners from './partners';
import defaultGlobalStyles from './styles/capitalOne/globalStyles';
import defaultTheme from './styles/capitalOne/index';
import defaultContent from './text/brands/capitalOne/content';
import { TextStore } from './text/textStore';
import jsx from './text/transformers/jsx';

const ThemeProvider = ({ children }: any) => {
    const brand = useBrand();
    const [theme, setTheme] = useState({
        globalTheme: undefined,
        GlobalStyles: undefined,
        content: undefined,
        themeLoaded: false
    });
    const { GlobalStyles, themeLoaded } = theme;

    useEffect(() => {
        const loadTheme = async () => {
            try {
                const { default: dynamicTheme } = await import(`./styles/${brand}/theme/index.ts`);
                const { default: dynamicGlobalStyles } = await import(`./styles/${brand}/global/index.ts`);
                const { default: partnerContent } = await import(`./text/brands/${brand}/content.ts`);

                const textContent = merge({}, defaultContent, partnerContent);

                setTheme({
                    globalTheme: dynamicTheme,
                    GlobalStyles: dynamicGlobalStyles,
                    content: textContent,
                    themeLoaded: true
                });
            } catch (e) {
                // eslint-disable-next-line no-console
                // @ts-expect-error TS2339: Property 'message' does not exist on type ''.
                console.log(e?.message);
                setTheme({
                    // @ts-expect-error TS2322: Type 'DefaultTheme &  components:  StyledLink: ( theme : any) => RuleSet<object>; StageHeading: ( th
                    globalTheme: defaultTheme,
                    // @ts-expect-error TS2322: Type 'NamedExoticComponent<ExecutionProps & object>' is not assignable to type 'undefined'.
                    GlobalStyles: defaultGlobalStyles,
                    // @ts-expect-error TS2322: Type ' AlreadyAppliedDecline:  Title: string; Paragraph1: string; Paragraph2: string; ContactUs: str
                    content: defaultContent,
                    themeLoaded: true
                });
            }
        };
        if (brand === partners.DEFAULT) {
            setTheme({
                // @ts-expect-error TS2322: Type 'DefaultTheme &  components:  StyledLink: ( theme : any) => RuleSet<object>; StageHeading: ( th
                globalTheme: defaultTheme,
                // @ts-expect-error TS2322: Type 'NamedExoticComponent<ExecutionProps & object>' is not assignable to type 'undefined'.
                GlobalStyles: defaultGlobalStyles,
                // @ts-expect-error TS2322: Type ' AlreadyAppliedDecline:  Title: string; Paragraph1: string; Paragraph2: string; ContactUs: str
                content: defaultContent,
                themeLoaded: true
            });
        } else {
            loadTheme();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [brand]);

    return (
        <>
            {themeLoaded && (
                <>
                    {/* @ts-expect-error TS2322: Type 'undefined' is not assignable to type 'ThemeArgument'. */}
                    <BaseThemeProvider theme={theme.globalTheme}>
                        {/* @ts-expect-error TS2604: JSX element type 'GlobalStyles' does not have any construct or call signatures. */}
                        <GlobalStyles />
                        <TextStore
                            transformers={{
                                template,
                                jsx
                            }}
                            value={theme.content}
                        >
                            {children}
                        </TextStore>
                    </BaseThemeProvider>
                </>
            )}
        </>
    );
};

ThemeProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export default ThemeProvider;
